import { Backdrop, Box, CircularProgress, Container, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, IconButton, Tooltip } from '@material-ui/core';
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles';
import { Print as PrintIcon } from '@material-ui/icons';
import EditIcon from '@material-ui/icons/Edit';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Button from '@mui/material/Button';
import Tab from '@mui/material/Tab';
import MUIDataTable from 'mui-datatables';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { useHistory } from 'react-router-dom';
import LoadingUI from '../../../components/ui/LoadingUI';
import PageTitle from '../../../components/ui/PageTitleUI';
import { useAuth } from '../../../hooks/auth';
import { ConciergeMonitor } from '../../../interfaces/Concierge';
import MvmStatus from '../../../interfaces/MvmStatus';
import MvmApi from '../../../services/MvmApi';
import ReportApi from '../../../services/ReportApi';
import getDefaultGridOptions from '../../../utils/componentUtils';
import utilsDate from '../../../utils/Date';
import permissions from '../../../utils/Permissions';
import alertgif from './images/alert.gif';
import MvmShedList from './MvmShedList';
import SearchMvmSummary from './SearchMvmSummary';
import { FIASA_PLANT_ID, MOPAR_PLANT_ID } from '../../../utils/constants';
import { useStyles } from '../Style';

interface IFormInput {
    mvmNumber: any;
    cartPlateNumber: string;
    vehicleTypeDescription: string;
    shippingCompanySupplier: string;
    shippingSupplier: string;
    entryConcierge: string;
    presentationPlantDate: string;
    entryAuthorizationDate: string;
    entryDate: string;
    submitDate: string;
    deliveryWindowDate: string;
    conciergeReleaseDate: string;
    exitDate: string;
    isAutorized: string;
    sheds: any;
}

const Manage: React.FC = () => {
    const { user, hasPermission } = useAuth();

    const [paramsConcierge, setParamsConcierge] = useState<ConciergeMonitor>({
        PlantId: +user.company.plantID,
        detailMode: false,
    });

    const history = useHistory()
    const classes = useStyles()
    const [mensagem, setMensagem] = useState('');
    const { t: tm } = useTranslation("Mvm")
    const { t: _t } = useTranslation("General")
    const { t: t } = useTranslation("Concierge")
    const { t: tMvm } = useTranslation("Mvm")
    const [circularLoading, setCircularLoading] = useState(false)
    const [dialogMensagemOpen, setDialogMensagemOpen] = useState(false)
    const [mvmId, setMvmId] = useState<any>(null)
    const [loading, setLoading] = useState<boolean>(false);
    const [selectedMvm, setSelectedMvm] = useState<any>(null);
    const [destinationTrailer, setDestinationTrailer] = useState('');
    const { control, handleSubmit, setValue } = useForm<IFormInput>(
        {
            defaultValues: {
                mvmNumber: {},
                cartPlateNumber: '',
                vehicleTypeDescription: '',
                shippingCompanySupplier: '',
                shippingSupplier: '',
                entryConcierge: '',
                presentationPlantDate: '',
                entryAuthorizationDate: '',
                entryDate: '',
                submitDate: '',
                deliveryWindowDate: '',
                conciergeReleaseDate: '',
                exitDate: '',
                isAutorized: '',
                sheds: [],
            }
        })

    const { isLoading, isFetching, data, refetch } = useQuery('veiclesInConcierge', async () => {
        return await MvmApi.searchConciergeMonitor(paramsConcierge);
    }, {
        staleTime: 1000 * 120, //calculado em milisegundos - Propriedade para setar qto tempo o cache fica válido
        refetchInterval: 1000 * 120, //calculado em milisegundos - Propriedade para setar qto tempo vai buscar o cache novamente
        refetchOnWindowFocus: false,
        retry: false,
    });



    useEffect(() => {
        if (!hasPermission(permissions.CONCIERGE.Add) && !hasPermission(permissions.CONCIERGE.Manage))
            history.replace('NoPermission');

        setParamsConcierge({ ...paramsConcierge, PlantId: +user?.company?.plantID });

    }, [history, user]);

    useEffect(() => {
        refetch();
    }, [paramsConcierge])

    function print(id: string) {
        ReportApi.printMvm(id);
    }

    const columns = [
        {
            name: 'isAutorized',
            options: {
                display: false,
            }
        },
        {
            name: 'conciergeReleaseDate',
            options: {
                display: false,
            }
        },
        {
            name: 'mvmId',
            options: {
                display: false,
            }
        },
        {
            name: 'firstShed',
            options: {
                display: false,
            }
        },
        {
            name: 'dock',
            options: {
                display: false,
            }
        }, {
            name: '',
            label: '',
            options: {
                display: +user.company.plantID === FIASA_PLANT_ID ? true : false,
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: (cellValue: string, rowIndex: number, columnIndex: number) => ({
                    align: "center",
                    style: {
                        width: 40,
                        backgroundColor: data![rowIndex].releaseStatusFlag != 'WHITE' ? data![rowIndex].releaseStatusFlag : ''
                    }

                })
            }

        },
        {
            name: '',
            label: '',
            options: {
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: () => ({
                    align: "center"
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {

                    const showReleaseButton = tableMeta.rowData[0] == 'True' && (tableMeta.rowData[1] == null || tableMeta.rowData[1] === '')
                    const showCancelAuthorization = +user.company.plantID === MOPAR_PLANT_ID && tableMeta.rowData[0] == 'True'
                    const showReleaseXD = tableMeta.rowData[3] == 'XD';
                    return (
                        <>
                            {showReleaseButton && (
                                <Button
                                    variant="outlined"
                                    style={{ height: "100%", width: "100%", fontSize: "0.7rem", padding: "2px", marginBottom: 5 }}
                                    onClick={() => handleDialogClickOpenRelease(tableMeta.rowData[2], tableMeta.rowData[3], tableMeta.rowData[4])}>
                                    {showReleaseXD ? t('releaseXD') : t('release')}
                                </Button>)}
                            {showCancelAuthorization && showReleaseButton && <Button
                                variant="outlined"
                                style={{ height: "100%", width: "100%", fontSize: "0.7rem", padding: "2px", color: "red" }}
                                onClick={() => handleDialogClickOpenCancelAuthorizationEntry(tableMeta.rowData[2])}>
                                {tMvm('cancelAuthorizationEntry')}
                            </Button>}
                        </>
                    );
                }
            }
        },
        {
            name: 'mvmNumber',
            label: tm('mvmNumber'),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: () => ({
                    align: "center"
                }),
            }
        }, {
            name: 'vehiclePlateNumber',
            label: t("plateNumber"),
        }, {
            name: 'destinationTrailer', // ????????????
            label: t("cartDestination")
        }, {
            name: 'shippingSupplierCorporateName',
            label: t("supplier"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
            }
        }, {
            name: 'vehicleTypeDescription',
            label: t("vehicleType"),

        }, {
            name: 'deliveryWindowDate',
            label: t("windowTime"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: () => ({
                    align: "center"
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    return utilsDate.DateTimeShort(value)
                }
            }
        }, {
            name: 'scheduleDate',
            label: t("conciergeCheckIn"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: () => ({
                    align: "center"
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    return utilsDate.DateTimeShort(value)
                }
            }
        }, {
            name: 'windowStatusDescription',
            // label: 'STATUS JANELA',
            label: t("windowStatus"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: (cellValue: string, rowIndex: number, columnIndex: number) => ({
                    align: "center",
                    style: {
                        backgroundColor: data![rowIndex].windowStateFlag != 'WHITE' ? data![rowIndex].windowStateFlag : '',
                        color: data![rowIndex].windowStateFlag != "YELLOW" && data![rowIndex].windowStateFlag != "WHITE" ? "white" : "black"
                    }

                })
            }

        }, {
            name: 'criticalMaterialExist',
            label: t("criticalMaterial"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: () => ({
                    align: "center"
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    return (
                        <Box display='flex' alignItems='center' justifyContent='center'>
                            {value == 'S' ?
                                (
                                    <>
                                        <img src={alertgif} title={t("alert")} height={24} width={24} style={{ marginRight: 5, }} /> {_t("yes")}
                                    </>
                                ) :
                                _t("no")}
                        </Box>
                    );
                }
            }
        },
        {
            name: '',
            label: '',
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: () => ({
                    align: "center"
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    return (
                        <>
                            <Box display="flex">
                                <Tooltip title={String(_t('print'))}>
                                    <IconButton
                                        disabled={(!hasPermission(permissions.MVM.SuperUser) && !hasPermission(permissions.MVM.Print)) || tableMeta.rowData[1] === MvmStatus.FLAG_STATUS_DRAFT}
                                        aria-label={_t('print')}
                                        color="primary"
                                        onClick={() => print(tableMeta.rowData[2])}
                                    >
                                        <PrintIcon fontSize='small' />
                                    </IconButton>
                                </Tooltip>
                            </Box>
                        </>
                    );
                }
            }
        }, {
            name: '',
            label: '',
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                }),
                setCellProps: () => ({
                    align: "center"
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    return (
                        <Box display="flex">
                            <a href={'/RegisterVehicleArrival/' + tableMeta.rowData[2]}>
                                <IconButton aria-label="Edit" color="primary">
                                    <EditIcon fontSize='small' />
                                </IconButton>
                            </a>
                        </Box>
                    );
                }
            }
        }
    ]

    const myTheme = createTheme({
        overrides: {
            MuiTableBody: {
                root: {
                    cursor: ''
                }
            },
            MuiTableRow: {
                root: { '&$selected, &$selected:hover': { backgroundColor: '#d9e6f3', } }
            },
            MuiTableCell: {
                root: {
                    paddingLeft: 4,
                    paddingRight: 4,
                    paddingBottom: 10,
                    paddingTop: 10
                },
                head: {
                    height: 52
                }
            },
            MUIDataTableSelectCell: {
                root: {
                    display: "none"
                }
            }
        }
    })

    const [tab, setTab] = React.useState('1');

    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setTab(newValue);
    };

    const [dialogOpen, setDialogOpen] = React.useState(false);
    const [openBackdrop, setOpenBackdrop] = React.useState(false);

    // Ações configuradas 
    // 1 = Liberar
    // 2 = Cancelar Autorização Entrada
    const handleConfirmation = async () => {
        setOpenBackdrop(true);
        setDialogOpen(false);

        switch (actionType) {
            case 1:
                await releaseMvm()
                break;
            case 2:
                await cancelEntryAuthorization()
                break;
            default:
                break;
        }

        setActionType(0)
    };

    const releaseMvm = async () => {
        try {
            await MvmApi.updateReleaseDate(mvmId);

            if (+user.company.plantID === MOPAR_PLANT_ID) {
                setMensagem(t("confirmationMessageMopar") + destinationTrailer);
            }
            else {
                setMensagem(t("confirmationMessage") + destinationTrailer);
            }

            setDialogMensagemOpen(true);
            await refetch({ queryKey: 'veiclesInConcierge' });
        } catch (error) {
            setMensagem(t('releaseError'));
            setDialogMensagemOpen(true);
            await refetch({ queryKey: 'veiclesInConcierge' });
        }
    }

    const cancelEntryAuthorization = async () => {
        await MvmApi.cancelAuthorizationPlantEntry(mvmId).then(() => {
            setMensagem(tMvm("authorizationEntryCanceled"))
        })
            .catch((err) => {
                setMensagem(tMvm('cancelAuthorizationEntryError'))
            })
            .finally(async () => {
                setDialogMensagemOpen(true)
                await refetch({ queryKey: 'veiclesInConcierge' })
            })
    }

    // Ações configuradas 
    // 1 = Liberar
    // 2 = Cancelar Autorização Entrada
    const [actionType, setActionType] = useState<number>(0);

    const handleDialogClickOpenRelease = (idMvm: number, destination: string, dock: string) => {
        setMvmId(idMvm)
        if (dock != null && dock != undefined)
            setDestinationTrailer(dock)
        else
            setDestinationTrailer(destination)

        setMensagem(t('wishRelease'))
        setDialogOpen(true)
        setActionType(1)
    };

    const handleDialogClickOpenCancelAuthorizationEntry = (idMvm: number) => {
        setMvmId(idMvm)
        setMensagem(tMvm("cancelAuthorizationEntryConfirmation"))
        setDialogOpen(true)
        setActionType(2)
    };

    const handleDialogClickClose = () => {
        setOpenBackdrop(false)
        setDialogOpen(false)
        setActionType(0)
    };

    const closeDialogMensagem = () => {
        setDialogMensagemOpen(false);
        setOpenBackdrop(false);
    }


    const onSelect = async (currentRowsSelected: any, allRowsSelected: any, rowsSelected: any) => {
        if (allRowsSelected.length > 0) {
            setSelectedMvm(data[currentRowsSelected[0].index]);
            const sheds = await MvmApi.getShedListById(data[currentRowsSelected[0].index].mvmId);

            setValue('sheds', sheds);
        } else {
            setSelectedMvm(null);
            setValue('sheds', []);
        }

    }

    return (
        <Container maxWidth={false} component="main">
            <Backdrop className={classes.backdrop} open={openBackdrop || isLoading || isFetching}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <Dialog
                open={dialogOpen}
                onClose={handleDialogClickClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {actionType == 1 ? t('releasement') : tMvm('cancelAuthorizationEntry')}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {mensagem}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDialogClickClose}>{"Cancelar"}</Button>
                    <Button onClick={() => handleConfirmation()} autoFocus>{"Sim"}</Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={dialogMensagemOpen}
                onClose={closeDialogMensagem}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Atenção"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {mensagem}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => closeDialogMensagem()} autoFocus>{"OK"}</Button>
                </DialogActions>
            </Dialog>

            <PageTitle title={t("conciergeTitle")} />
            <div className={classes.rootContent}>
                <div className={classes.paper}>
                    <Backdrop style={{ zIndex: 9999 }} open={circularLoading}>
                        <CircularProgress color="inherit" />
                    </Backdrop>
                    <TabContext value={tab}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <TabList onChange={handleChange}>
                                <Tab label={t("concierge")} value="1" />
                                <Tab label={t("mvmTitleSearch")} value="2" />
                            </TabList>
                        </Box>

                        <TabPanel value="1" className={classes.tabPadding}>
                            {
                                loading ? <LoadingUI /> :
                                    <>
                                        <span onClick={() => history.push('/registerVehicleArrival')}
                                            style={{
                                                display: 'inline',
                                                color: '#597DDA', cursor: 'pointer',
                                                textDecoration: 'underline', fontWeight: 'bold',
                                                fontSize: 16
                                            }}>
                                            {tm("registerVehicleArrival")}
                                        </span>
                                        <p>{_t("totalRecords")} {data && data.length > 0 ? data.length : '0'}</p>

                                        <MuiThemeProvider theme={myTheme}>
                                            <MUIDataTable
                                                title=""
                                                data={data}
                                                columns={columns}
                                                options={{
                                                    ...getDefaultGridOptions(_t),
                                                    serverSide: true,
                                                    pagination: false,
                                                    sort: false,
                                                    selectToolbarPlacement: "none",
                                                    filter: false,
                                                    search: false,
                                                    download: false,
                                                    print: false,
                                                    viewColumns: false,
                                                    selectableRows: 'single',
                                                    selectableRowsOnClick: true,
                                                    onRowSelectionChange: onSelect,
                                                    selectableRowsHideCheckboxes: true,
                                                    selectableRowsHeader: false,
                                                }}

                                            />
                                        </MuiThemeProvider>
                                        {selectedMvm && (
                                            <Grid container spacing={1}>
                                                <Grid item xs={12}>
                                                    <MvmShedList
                                                        control={control}
                                                        name={"sheds"}
                                                        resumido={false}
                                                        mvmNumber={selectedMvm?.mvmNumber}
                                                    />
                                                </Grid>
                                            </Grid>
                                        )}
                                    </>
                            }
                        </TabPanel>
                        <TabPanel value="2">
                            <SearchMvmSummary showSheds={true} showInvoices={true} />
                        </TabPanel>
                    </TabContext>
                </div>
            </div>
        </Container>
    )
}
export default Manage;
